import { useGlobalPermissions } from '../../query-hooks/global-permissions';

import type { TranslationKey } from '../../../../../shared/source/internationalization/translation';

type TabKey = 'employees' | 'jobs' | 'learningOpportunities' | 'skills';

export type TabConfig = {
    readonly key: TabKey;
    readonly translationKey: TranslationKey;
};

const availableTabs: Record<TabKey, TabConfig> = {
    employees: {
        key: 'employees',
        translationKey: 'pages.global-search.navigation.employees',
    },
    jobs: {
        key: 'jobs',
        translationKey: 'pages.global-search.navigation.job-openings',
    },
    learningOpportunities: {
        key: 'learningOpportunities',
        translationKey: 'pages.global-search.navigation.learning-opportunities',
    },
    skills: {
        key: 'skills',
        translationKey: 'pages.global-search.navigation.skills',
    },
};

export const useFilterTabsByPermission = (): readonly TabConfig[] => {
    const { data: globalPermissions } = useGlobalPermissions();
    const canUserSeeSkillTab = globalPermissions?.canSearchSkills ?? false;
    const canUserSeeEmployeesTab = globalPermissions?.canSearchUsers ?? false;
    const canUserSeeJobsTab = globalPermissions?.canSearchJobs ?? false;
    const canUserSeeLearningOpportunitiesTab = globalPermissions?.canSearchLearningOpportunities ?? false;

    const permittedTabs: TabConfig[] = [];

    if (canUserSeeSkillTab) {
        permittedTabs.push(availableTabs.skills);
    }

    if (canUserSeeEmployeesTab) {
        permittedTabs.push(availableTabs.employees);
    }

    if (canUserSeeJobsTab) {
        permittedTabs.push(availableTabs.jobs);
    }

    if (canUserSeeLearningOpportunitiesTab) {
        permittedTabs.push(availableTabs.learningOpportunities);
    }

    return permittedTabs;
};
